// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_deleteDevelopmentProjectDraft(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["DevelopmentProjectDraftWasDeleted"]);
}

let variablesConverter = {"deleteDevelopmentProjectDraftInput":{},"__root":{"input":{"r":"deleteDevelopmentProjectDraftInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"deleteDevelopmentProjectDraft":{"u":"response_deleteDevelopmentProjectDraft"}}};

let wrapResponseConverterMap = {
  response_deleteDevelopmentProjectDraft: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"deleteDevelopmentProjectDraft":{"u":"response_deleteDevelopmentProjectDraft"}}};

let responseConverterMap = {
  response_deleteDevelopmentProjectDraft: unwrap_response_deleteDevelopmentProjectDraft
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "draftNodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteDevelopmentProjectDraft",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "DevelopmentProjectDraftWasDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteDevelopmentProjectDraft",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "draftNodeId",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "DevelopmentProjectDraftWasDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "afb35beaa5da32b41e93304b622efb93",
    "id": null,
    "metadata": {},
    "name": "MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation",
    "operationKind": "mutation",
    "text": "mutation MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation(\n  $input: DeleteDevelopmentProjectDraftInput!\n) {\n  deleteDevelopmentProjectDraft(input: $input) {\n    __typename\n    ... on DevelopmentProjectDraftWasDeleted {\n      draftNodeId\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_deleteDevelopmentProjectDraft = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_deleteDevelopmentProjectDraft = unwrap_response_deleteDevelopmentProjectDraft;
exports.wrap_response_deleteDevelopmentProjectDraft = wrap_response_deleteDevelopmentProjectDraft;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
